<template>
    <div>
        <v-row>
            <v-col style="position: relative">
                <v-select class="mb-2" hide-details solo label="Første række" v-model="firstRow" :items="filteredRows['firstRow']" />
                <v-select hide-details solo label="Anden række" v-model="secondRow" :items="filteredRows['secondRow']" />
                <v-btn class="switch-rows-button white--text" fab small @click="switchRows" color="third">
                    <v-icon size="medium">
                        fa-sync-alt
                    </v-icon>
                </v-btn>            
            </v-col>
            <v-col>
                <range-picker
                    :solo="true"
                    storeName="naestved"
                    rangeName="range"
                    periodName="period"
                    :presets="$store.state.naestved.presets"
                />
            </v-col>
        </v-row>
        <v-row>
            <v-col cols="3" v-for="({ header, value, formatter }, index) in totalCards" :key="index">
                <total-card :header="header" :value="value(totals)" :formatter="formatter" :loading="loading" />
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-right">
                <v-btn-toggle
                mandatory
                v-model="selectedFieldGroup"
                >
                    <v-btn v-for="(fieldGroup, index) in fieldGroups" :key="index">
                        {{ fieldGroup.text }}
                    </v-btn>
                </v-btn-toggle>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <v-card>
                    <loader v-if="loading" />
                    <sales-pivot
                        v-else
                        defaultSort="count"
                        :dataObject="stats"
                        :fields="filteredFields"
                        :nestedFields="nestedFields"
                        :valueFunctions="valueFunctions" 
                        equalCols />
                </v-card>
            </v-col>
        </v-row>
    </div>
</template>

<script>
import SalesPivot from '@/components/salesPivot.vue'
import RangePicker from '@/components/rangePicker.vue'
import TotalCard from '@/components/totalCard'

export default {
    components: {
        SalesPivot,
        RangePicker,
        TotalCard
    },
    data () {
        return {
            loading: true,
            stats: null,
            firstRow: 'booker',
            secondRow: 'kampagne',
            rows: [
                {
                    text: 'Phoner',
                    value: 'booker'
                },
                {
                    text: 'Kampagne',
                    value: 'kampagne'
                }
            ],
            selectedFieldGroup: 0,
            totalCards: [
                {
                    header: 'Uploadede brutto',
                    formatter: this.$options.filters.separator,
                    value: v => v.count
                },
                {
                    header: 'Uploadede netto',
                    formatter: this.$options.filters.separator,
                    value: v => v.count - (v.existing || 0) - (v.noProducts || 0) - (v.noConsent || 0) - (v.unqualified || 0) - (v.wrongNumber || 0)
                },
                {
                    header: 'Afsluttede',
                    formatter: this.$options.filters.separator,
                    value: v => v.count - (v.new + v.automaticRedials + v.privateRedials)
                },
                {
                    header: 'Solgt præmie',
                    formatter: this.$options.filters.separator,
                    value: v => v.total
                },
                {
                    header: 'Salg pr. uploaded brutto',
                    formatter: this.$options.filters.separator,
                    value: v => v.total / (v.count || 1)
                },
                {
                    header: 'Salg pr. uploaded netto',
                    formatter: this.$options.filters.separator,
                    value: v => v.total / (v.count - (v.existing || 0) - (v.noProducts || 0) - (v.noConsent || 0) - (v.unqualified || 0) - (v.wrongNumber || 0) || 1)
                },
                {
                    header: 'Salg pr. afsluttet',
                    formatter: this.$options.filters.separator,
                    value: v => v.total / ((v.count - (v.new + v.automaticRedials + v.privateRedials)) || 1)
                }
            ],
            fieldGroups: [
                {
                    text: 'Status',
                    fields: ['count', 'open', 'closed']
                },
                {
                    text: 'Åbne',
                    fields: ['count', 'open', 'new', 'automaticRedials', 'privateRedials']
                },
                {
                    text: 'Afsluttede',
                    fields: ['count', 'closed', 'success', 'notInterested', 'existing', 'noProducts', 'noConsent', 'unqualified', 'wrongNumber', 'maxCalls']
                },
                {
                    text: 'Salg',
                    fields: ['count', 'closed', 'success', 'avgLead', 'avgUploaded', 'total', 'avgSuccess']
                }
            ],
            fields: [
                {
                    header: 'Upl.',
                    field: 'count',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Åbne',
                    field: 'open',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Afsluttede',
                    field: 'closed',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Ubhl.',
                    field: 'new',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Aut.',
                    field: 'automaticRedials',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Priv.',
                    field: 'privateRedials',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Antal salg',
                    field: 'success',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Antal nej',
                    field: 'notInterested',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Tryg-knd.',
                    field: 'existing',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Ingen pro.',
                    field: 'noProducts',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Intet s.t.',
                    field: 'noConsent',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Ukval.',
                    field: 'unqualified',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Ugyl.',
                    field: 'wrongNumber',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Maks.',
                    field: 'maxCalls',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Solgt præmie',
                    field: 'total',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Gns. præmie',
                    field: 'avgSuccess',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Salg pr. afsluttet',
                    field: 'avgLead',
                    cols: '2',
                    formatter: this.$options.filters.separator
                },
                {
                    header: 'Salg pr. uploaded',
                    field: 'avgUploaded',
                    cols: '2',
                    formatter: this.$options.filters.separator
                }
            ],
            nestedFields: ['count', 'new', 'automaticRedials', 'privateRedials', 'success', 'notInterested', 'noProducts','noConsent', 'unqualified', 'wrongNumber', 'maxCalls', 'total'],
            valueFunctions: {
                open: v => v.new + v.automaticRedials + v.privateRedials,
                closed: v => v.count - (v.new + v.automaticRedials + v.privateRedials),
                avgLead: v => v.total / (v.count - (v.new + v.automaticRedials + v.privateRedials)),
                avgUploaded: v => v.total / v.count,
                avgSuccess: v => v.total / v.success
            }
        }
    },
    computed: {
        totals() {
            const totals = this.$reduceNested(this.stats, this.nestedFields)
            return {
                ...totals,
                maxDiff: this.maxDiff
            }
        },
        filteredFields () {
            if (this.fieldGroup.fields.length) {
                return this.fields.filter(field => {
                    return this.fieldGroup.fields && this.fieldGroup.fields.includes(field.field)
                })
            } else return this.fields
        },
        fieldGroup () {
            return this.fieldGroups[this.selectedFieldGroup]
        },
        filteredRows () {
            return {
                firstRow: this.rows.filter(row => row.value !== this.secondRow),
                secondRow : this.rows.filter(row => row.value !== this.firstRow),
            }
        },
        range () {
            return this.$store.state.naestved.range
        },
        period () {
            return this.$store.state.naestved.period
        }
    },
    methods: {
        async getData () {
            this.loading = true
            const response = await this.$http().get(('pii'), {
                params: {
                    startDate: this.range[0],
                    endDate: this.range[1],
                    firstKey: this.firstRow,
                    secondKey: this.secondRow
                }
            })
            this.stats = response.data
            this.loading = false
        },
        switchRows () {
            const tempFirstRow = this.firstRow
            this.firstRow = this.secondRow
            this.secondRow = tempFirstRow
        }
    },
    watch: {
        firstRow: function () {
            this.getData()
        },
		range: {
			handler({ length }) {
                if (length === 2) this.getData();
			},
			deep: true
        },
        period: function () {
		    this.$store.commit("naestved/setRange", this.$store.state.naestved.period);
        }
    },
    created () {
        this.getData()
    }
}
</script>